import { IGoalStreakInfo } from "motw_core/DTOs/GoalStreakInfo/IGoalStreakInfo";
import { IGoal } from "motw_core/Entity/IGoal";

export function GetRealMomentum(goal: IGoal, goalStreakInfos: IGoalStreakInfo[]) {
    const goalStreakInfo = goalStreakInfos.find(
        (gsi) => gsi.result_goalid === goal.id
    );

    const realMomentum = goalStreakInfo ? goalStreakInfo.realMomentum : 0;

    return realMomentum;
}
